import React from 'react';

/**
 * AriseNshineLoader — animation removed per product decision.
 * Keeps the same exports (PageLoader / InlineLoader / SmallLoader / default)
 * so existing imports across the app remain valid, but renders a tiny,
 * static placeholder instead of the cross + sound-wave animation.
 */
const AriseNshineLoader = ({ text = '', showText = true }) => (
  <div className="flex items-center justify-center">
    {showText && text ? (
      <p className="text-zinc-500 text-sm">{text}</p>
    ) : null}
  </div>
);

export const PageLoader = ({ text = '' }) => (
  <div className="flex items-center justify-center h-screen bg-zinc-950">
    {text ? <p className="text-zinc-500 text-sm">{text}</p> : null}
  </div>
);

export const InlineLoader = ({ text = '' }) => (
  <div className="flex items-center justify-center py-8">
    {text ? <p className="text-zinc-500 text-sm">{text}</p> : null}
  </div>
);

export const SmallLoader = () => null;

export default AriseNshineLoader;
